"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMExceptionCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../../../interfaces/vm-transformers/IVMScopeManager");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../../node/NodeGuards");
const VMDestructuringBytecodeCompiler_1 = require("../VMDestructuringBytecodeCompiler");
let VMExceptionCompiler = class VMExceptionCompiler {
    compileThrowStatement(node, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.argument);
        builder.throw();
    }
    compileTryStatement(node, context) {
        var _a, _b, _c;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const tryStartIndex = context.instructions.length;
        builder.tryStart(undefined, undefined, 0);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.statement(node.block);
        builder.tryEnd();
        const afterTryJump = builder.jump();
        let catchStartIndex;
        let afterCatchJump;
        let catchEnvHandle = null;
        if (node.handler) {
            catchStartIndex = context.instructions.length;
            const addedToEnvVars = [];
            if (!node.handler.param) {
                builder.catchStart(-1);
            }
            else if (NodeGuards_1.NodeGuards.isIdentifierNode(node.handler.param)) {
                const paramName = node.handler.param.name;
                const shadowsOuterVar = this.vmCompilerUtils.isDeclaredInParentScope(paramName, context);
                if (shadowsOuterVar) {
                    catchEnvHandle = this.scopeManager.enterEnv(context, builder);
                }
                if (!context.envVars.has(paramName)) {
                    addedToEnvVars.push(paramName);
                }
                context.envVars.add(paramName);
                const paramNameIndex = context.constantPool.add(paramName);
                builder.catchStart(paramNameIndex);
            }
            else if (NodeGuards_1.NodeGuards.isObjectPatternNode(node.handler.param) ||
                NodeGuards_1.NodeGuards.isArrayPatternNode(node.handler.param)) {
                const patternVarNames = this.vmCompilerUtils.extractIdentifiersFromPattern(node.handler.param);
                let needsNewEnv = false;
                for (const varName of patternVarNames) {
                    if (this.vmCompilerUtils.isDeclaredInParentScope(varName, context)) {
                        needsNewEnv = true;
                        break;
                    }
                }
                if (needsNewEnv) {
                    catchEnvHandle = this.scopeManager.enterEnv(context, builder);
                }
                const tempVarName = `__exception_${context.instructions.length}`;
                context.envVars.add(tempVarName);
                const tempVarIndex = context.constantPool.add(tempVarName);
                builder.catchStart(tempVarIndex);
                this.vmCompilerUtils.emitLoadVariable(tempVarName, context);
                for (const varName of patternVarNames) {
                    if (!context.envVars.has(varName)) {
                        addedToEnvVars.push(varName);
                    }
                    context.envVars.add(varName);
                }
                const previousDeclarationKind = context._declarationKind;
                context._declarationKind = 'const';
                this.destructuringCompiler.compileDestructuringPattern(node.handler.param, context, true);
                context._declarationKind = previousDeclarationKind;
            }
            else {
                builder.catchStart(-1);
            }
            (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.statement(node.handler.body);
            if (catchEnvHandle) {
                this.scopeManager.exitEnv(context, builder, catchEnvHandle);
                for (const varName of addedToEnvVars) {
                    context.envVars.delete(varName);
                }
            }
            afterCatchJump = builder.jump();
        }
        let finallyStartIndex;
        if (node.finalizer) {
            afterTryJump.patchToHere();
            if (afterCatchJump !== undefined) {
                afterCatchJump.patchToHere();
            }
            finallyStartIndex = context.instructions.length;
            builder.finallyStart();
            (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.statement(node.finalizer);
            builder.finallyEnd();
        }
        else {
            afterTryJump.patchToHere();
            if (afterCatchJump !== undefined) {
                afterCatchJump.patchToHere();
            }
        }
        const endIndex = context.instructions.length;
        const tryStartInstruction = context.instructions[tryStartIndex];
        tryStartInstruction.catchIndex = catchStartIndex;
        tryStartInstruction.finallyIndex = finallyStartIndex;
        tryStartInstruction.endIndex = endIndex;
    }
};
exports.VMExceptionCompiler = VMExceptionCompiler;
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils),
    __metadata("design:type", typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object)
], VMExceptionCompiler.prototype, "vmCompilerUtils", void 0);
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager),
    __metadata("design:type", typeof (_b = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _b : Object)
], VMExceptionCompiler.prototype, "scopeManager", void 0);
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMDestructuringBytecodeCompiler),
    __metadata("design:type", typeof (_c = typeof VMDestructuringBytecodeCompiler_1.VMDestructuringBytecodeCompiler !== "undefined" && VMDestructuringBytecodeCompiler_1.VMDestructuringBytecodeCompiler) === "function" ? _c : Object)
], VMExceptionCompiler.prototype, "destructuringCompiler", void 0);
exports.VMExceptionCompiler = VMExceptionCompiler = __decorate([
    (0, inversify_1.injectable)()
], VMExceptionCompiler);
